import { render } from "./Quizzes.vue?vue&type=template&id=68db1de4"
import script from "./Quizzes.vue?vue&type=script&lang=js"
export * from "./Quizzes.vue?vue&type=script&lang=js"

import "@vueform/multiselect/themes/default.css?vue&type=style&index=0&lang=css"
script.render = render

export default script